import React from 'react';
import { useIntl } from 'react-intl';
import { useFragment, graphql, useMutation } from 'react-relay/hooks';
import { Flexbox, Switch } from '@sonika-se/ui-kit/components';
export const EditEventIsCustomSalaryCode = (props) => {
    const { eventRef } = props;
    const intl = useIntl();
    const { id, isCustomSalaryCode } = useFragment(graphql `
      fragment EditEventIsCustomSalaryCode_event on Event {
        id
        isCustomSalaryCode
      }
    `, eventRef);
    const [updateEvent, updateEventLoading] = useMutation(graphql `
    mutation EditEventIsCustomSalaryCodeMutation($model: UpdateEventRequestInput!) {
      updateEvent(model: $model) {
        eventEdge {
          node {
            id
            isCustomSalaryCode
          }
        }
      }
    }
  `);
    return (<Flexbox align="center">
      <Switch disabled={updateEventLoading} checked={isCustomSalaryCode} label={intl.formatMessage({
            id: 'EventSettings.isCustomSalaryCode',
            defaultMessage: 'Används för speciallönearter',
        })} onChange={() => {
            updateEvent({
                variables: {
                    model: {
                        id,
                        isCustomSalaryCode: !isCustomSalaryCode,
                    },
                },
            });
        }}/>
    </Flexbox>);
};
export default EditEventIsCustomSalaryCode;
